import png1 from "./1.jpg";
import png2 from "./2.jpg";
import png3 from "./3.jpg";
import png4 from "./4.jpg";
import png5 from "./5.jpg";
import png6 from "./6.jpg";
export const gpzxyh = [
  {
    name: "查找流水",
    msgList: [
      {
        msg: "登录中信银行APP->点击【我的】->点击【交易明细】->点击【...】->点击【流水证明】",
      },
      { imgs: [png1, png2, png3] },
    ],
  },
  {
    name: "发送账单",
    msgList: [
      {
        msg: "证明用途【其它】，交易时间【自定义近一年】->点击【我要申请】->填入专属邮箱【发送】",
      },
      { imgs: [png4, png5, png6] },
    ],
  },
  {
    name: "注意事项",
    msgList: [
      {
        msg: "证明用途【其它】交易时间【自定义近一年】【开立成功】后发送至专属邮箱",
      },
    ],
  },
];
